 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		12: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		12: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"19424aaf179678dd55bfbeddb3167a7124f4321c","3":"3d408ffa4de1f259a0242cadf3ce5ff7215313a7","4":"c5d030c83c501248f04653939ec89374a0d98d5d","5":"26fea897106d8025e40f7e098d882833240f2460","6":"3598bff3e2791461c2141ebacb8fa278ee383104","7":"500f4124e5ea103f65bf9236213522ce718704c5","8":"6aea75f5aee8299a072464dd561e2617c8127f94","9":"9dc48eaad5fd556cc3a0ae947874f8e398d8cd5e","10":"dd30976522ca1e15806d4fb8d498708681095b6c","11":"f7fc25985e404cad5b06f73a5c2c4afd63f0393c","14":"component---src-pages-404-js","15":"component---src-pages-api-en-js","16":"component---src-pages-api-zh-hk-js","17":"component---src-pages-api-zh-js","18":"component---src-pages-commands-alexa-js","19":"component---src-pages-commands-google-js","20":"component---src-pages-commands-index-js","21":"component---src-pages-contact-en-js","22":"component---src-pages-contact-zh-hk-js","23":"component---src-pages-contact-zh-js","24":"component---src-pages-creator-en-js","25":"component---src-pages-creator-zh-hk-js","26":"component---src-pages-creator-zh-js","27":"component---src-pages-customers-en-js","28":"component---src-pages-customers-zh-hk-js","29":"component---src-pages-customers-zh-js","30":"component---src-pages-ihome-js","31":"component---src-pages-index-en-js","32":"component---src-pages-index-zh-hk-js","33":"component---src-pages-index-zh-js","34":"component---src-pages-pricing-ecommerce-en-js","35":"component---src-pages-pricing-ecommerce-zh-hk-js","36":"component---src-pages-pricing-ecommerce-zh-js","37":"component---src-pages-pricing-en-js","38":"component---src-pages-pricing-zh-hk-js","39":"component---src-pages-pricing-zh-js","40":"component---src-pages-terms-en-js","41":"component---src-pages-terms-zh-hk-js","42":"component---src-pages-terms-zh-js"}[chunkId]||chunkId) + "-" + {"0":"4a65ae703e0c8621a36e","1":"e9d24b1846c7d6eb9685","2":"eb81cbf356c5f1436794","3":"70f060d7eba666c2b0c5","4":"cb74b1e5f3a9f71bec80","5":"e85afe468db360ae080c","6":"ed369d5b070e5d6adbb6","7":"d62f4676acb2552302ef","8":"58a96313549ef8a45931","9":"dfba40cae61c4f5861fe","10":"5a9eb60cf1d8cfbacbfe","11":"9e7d5a8dfe2c13129dbf","14":"09fe4bbb98425c581575","15":"4575b8f15c6bbd67d175","16":"dcfe2627fbf2dee77f5e","17":"cddfc281bb8e311720eb","18":"735bbe9ae8a51bdadeed","19":"3dd424765a2a2362bfc2","20":"3f1dc433b6a61c5d10fd","21":"34246116c5f4b2054513","22":"b8076d4dc934840971a8","23":"0ef3c8afb2fa0d712323","24":"876bf06c67446905edd9","25":"bd6b48c21ce532a35e8b","26":"ddb10eb5acd4ec576d61","27":"de652001b7d402c1171b","28":"9cd8db97df97a4b70d77","29":"baf82455b5e2bb4b932e","30":"f648c141f18834895bd5","31":"bc39083d220c09244f5c","32":"386c6b38c5ee9bcad427","33":"c4764c4a48b4e6d62e96","34":"bd5fd40b79135bce9e91","35":"db8b5ae39badfd690d0b","36":"d63daf062a41b7e4849d","37":"853812e8f06d9edde94b","38":"e650afdd462faa062153","39":"19a2ff59c31f1fcb0461","40":"1e01bb1b55a92dd0974f","41":"7f9e0972073b6960a33d","42":"cd31772a33f87e0ce46f","45":"56e8548a47c974522747"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"19424aaf179678dd55bfbeddb3167a7124f4321c","3":"3d408ffa4de1f259a0242cadf3ce5ff7215313a7","4":"c5d030c83c501248f04653939ec89374a0d98d5d","5":"26fea897106d8025e40f7e098d882833240f2460","6":"3598bff3e2791461c2141ebacb8fa278ee383104","7":"500f4124e5ea103f65bf9236213522ce718704c5","8":"6aea75f5aee8299a072464dd561e2617c8127f94","9":"9dc48eaad5fd556cc3a0ae947874f8e398d8cd5e","10":"dd30976522ca1e15806d4fb8d498708681095b6c","11":"f7fc25985e404cad5b06f73a5c2c4afd63f0393c","14":"component---src-pages-404-js","15":"component---src-pages-api-en-js","16":"component---src-pages-api-zh-hk-js","17":"component---src-pages-api-zh-js","18":"component---src-pages-commands-alexa-js","19":"component---src-pages-commands-google-js","20":"component---src-pages-commands-index-js","21":"component---src-pages-contact-en-js","22":"component---src-pages-contact-zh-hk-js","23":"component---src-pages-contact-zh-js","24":"component---src-pages-creator-en-js","25":"component---src-pages-creator-zh-hk-js","26":"component---src-pages-creator-zh-js","27":"component---src-pages-customers-en-js","28":"component---src-pages-customers-zh-hk-js","29":"component---src-pages-customers-zh-js","30":"component---src-pages-ihome-js","31":"component---src-pages-index-en-js","32":"component---src-pages-index-zh-hk-js","33":"component---src-pages-index-zh-js","34":"component---src-pages-pricing-ecommerce-en-js","35":"component---src-pages-pricing-ecommerce-zh-hk-js","36":"component---src-pages-pricing-ecommerce-zh-js","37":"component---src-pages-pricing-en-js","38":"component---src-pages-pricing-zh-hk-js","39":"component---src-pages-pricing-zh-js","40":"component---src-pages-terms-en-js","41":"component---src-pages-terms-zh-hk-js","42":"component---src-pages-terms-zh-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"9575fc0aa7aca91a729f","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
